import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import "./campaign.css";
import api from "../../../config/api";
import config from "../../../config/config";
import { getCurrentLoggedInSessionTokenWithPromise } from "../../../config/userPool";
import { Dialog } from "@progress/kendo-react-dialogs";
import moment from "moment";
import momentTZ from 'moment-timezone';
import { useDispatch, useSelector } from "react-redux";
import { REWARDS_CAMPAIGNS_ADD, REWARDS_CAMPAIGNS_LIST, REWARDS_OPERATORS_ADD } from "../../../routes";
import { AddCampaignHeader } from "./add_header";
import { AddCampaignSteps } from "./add_steps";
import { Button } from "@progress/kendo-react-buttons";
import { Icon } from "@progress/kendo-react-common";
import NextIcon from "../../../assets/communication/NextIcon.svg";
import UnsortIcon from "../../../assets/rewards/unsorted.svg";
import NoNominee from "../../../assets/rewards/no_nominee.svg";
import Docfile from "../../../assets/rewards/file.svg";
import DownloadIcon from "../../../assets/rewards/download.svg";
import { Loader } from "@progress/kendo-react-indicators";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import { createAndUpdateCampaign, createCampaignMatrix, deleteCampaignMatrixByModule, fetchCampaignApprovers, fetchCampaignConfig, fetchCampaignDetail, fetchCampaignInterchange, fetchCampaignMatrixList, fetchNominees, fetchTemplateDownloadURL, saveNominees, updateCampaignMatrix } from "../../../store/campaign";
import { CustomDatePicker } from "../../../components/custom/datepicker";
import { TextArea, TextBox } from "@progress/kendo-react-inputs";
import { ComboBox, DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { TimePicker } from "@progress/kendo-react-dateinputs";
import DatePicker from "react-datepicker";
import { fetchUserById } from "../../../store/userMgmt";
import { fetchAllProviderList } from "../../../store/rewardsOperator";
import NomineeSortableTable from "./tables/nominee_sortable_table";
import ErrorNomineeSortableTable from "./tables/error_nominee_sortable_table";

export const CreateUpdateCampaign = () => {

  const navigate = useNavigate();
  let { search } = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(search);
  const FileRef = useRef();
  const DocRef = useRef();

  const [imageLoading, setImageLoading] = useState(false);
  const [file, setFile] = useState("");
  const [doc, setDoc] = useState("");
  const [tempDoc, setTempDoc] = useState("");
  const [campaignTypeList, setCampaignTypeList] = useState([]);
  const [nomineeList, setNomineeList] = useState([]);
  const [invalidNomineeList, setInvalidNomineeList] = useState([]);

  const [showUploadOverrideWarning, setShowUploadOverrideWarning] = useState(false);

  const [showSubmitConfirmDialog, setShowSubmitConfirmDialog] = useState(false);

  const [showInvalidNomineeDialog, setShowInvalidNomineeDialog] = useState(false);
  const [campaignType, setCampaignType] = useState({});
  const [campaignCategory, setCampaignCategory] = useState({});
  const [rewardType, setRewardType] = useState({});
  const [filter, setFilter] = useState("");

  const [rewardProvider, setRewardProvider] = useState({});
  const minMinute = new Date(new Date().getTime() + 15 * 60000);

  const [showSaveDraftDialog, setShowSaveDraftDialog] = useState(false);
  const [clickDate, setClickDate] = useState(false);
  const [isEnableSaveAsDraft, setIsEnableSaveAsDraft] = useState(false);

  const [saveDraftMessage, setSaveDraftMessage] = useState("");

  const [selected_tab, setSelectedTab] = useState(
    parseInt(query.get("state", 0)) || 0
  );
  const [id, setId] = useState(
    query.get("id", "")
  );

  const userPermissions = getUserPermission();

  const AddPermssion = checkPermission(
    userPermissions,
    "gamifications.create_campaign"
  );

  const EditPermssion = checkPermission(
    userPermissions,
    "gamifications.update_campaign"
  );

  const UploadExcelPermssion = checkPermission(
    userPermissions,
    "gamifications.upload_nominees"
  );

  const ValidatorPermssion = checkPermission(
    userPermissions,
    "gamifications.campaign_validator"
  );

  const ApproverPermssion = checkPermission(
    userPermissions,
    "gamifications.campaign_approver"
  );

  const AdminPermssion = checkPermission(
    userPermissions,
    "gamifications.campaign_admin"
  );

  const { config_list, detail_data, template_download_loading, template_download, interchange_list } = useSelector(
    (state) => state.campaigns
  );

  const { provide_list } = useSelector(
    (state) => state.rewardsOperator
  );

  const [showRequiredFieldError, setShowRequiredFieldError] = useState(false);

  const [loading, setLoading] = useState(false);
  const [showDateError, setShowDateError] = useState(false);
  const [showPublishStartEndDateError, setShowPublishStartEndDateError] = useState(false);
  const [publishStartEndDateErrorMessage, setPublishStartEndDateErrorMessage] = useState("");

  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [errors, setErrors] = useState(false);
  const [showValidateError, setShowValidateError] = useState(false);
  const { CAMPAIGN_IMAGE_UPLOAD_ENDPOINT, CAMPAIGN_ENDPOINT, CAMPAIGN_FILE_UPLOAD_ENDPOINT } = config.api_endpoint;


  const [interchangeCombo, setInterchangeCombo] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState(null);
  const [selectedCampaignApprover, setSelectedCampaignApprover] = useState(null);
  const [campaignApproverCombo, setCampaignApproverCombo] = useState([]);
  const [defaultCampaignApproverCombo, setDefaultCampaignApproverCombo] = useState([]);
  const [nomineeApproverCombo, setNomineeApproverCombo] = useState([]);
  const [defaultNomineeApproverCombo, setDefaultNomineeApproverCombo] = useState([]);

  const [selectedInterchange, setSelectedInterchange] = useState([]);
  const [disabledInterchange, setDisableInterchange] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);


  const [error, setError] = useState({
    name: "",
    category: "",
    start_date: "",
    end_date: "",
    published_on: "",
    published_end: "",
  });
  const [disabled, setDisabled] = useState(false);

  const [rewardConfigurationTemp, setRewardConfigurationTemp] = useState({
    module_name: "",
    module_code: "",
    point: "",
    limit: "",
    threshold: "",
    task_description: "",
    popup_message: "",
  });


  const [rewardConfigurationList, setRewardConfigurationList] = useState([]);
  const [matrixModuleList, setMatrixModuleList] = useState([]);

  const [matrixLimitList, setMatrixLimitList] = useState([
    { name: 'No Limit', code: "unlimited" },
    { name: 'Day', code: "daily" },
    { name: 'Week', code: "weekly" },
  ]);

  const [firstRequest, setFirstRequest] = useState(true);


  const [editData, setEditData] = useState({
    status: "Draft",
    name: "",
    description: "",
    start_date: "",
    end_date: "",
    start_time: null,
    end_time: null,
    published_date: "",
    published_time: null,
    published_end_date: "",
    published_end_time: null,
    images: [""],
    images_url: [""],
    type: "",
    category: "",
    reward_type: "",
    provider: "",
    provider_id: "",
    value: 0.0,
    approver_id: "",
    approver_name: ""
  });

  const getData = async () => {

    if (id) {
      dispatch(fetchCampaignDetail(id)).then((res) => {
        // 

        if (res.payload.type == "Predefined Task Based") {
          reloadMatrixList();
          setCampaignType({ "name": res.payload.type });
        } else {
          if (nomineeList.length == 0) {
            dispatch(fetchNominees(id)).then((nomineePayload) => {

              if (nomineePayload.payload.status === "success") {
                setNomineeList(nomineePayload.payload.data);
              }

            });
          }
        }



        let payload = res.payload;

        // if (payload.status != 'draft' && payload.status != 'pendingapproval' && payload.status != 'scheduled') {
        //   navigate(REWARDS_CAMPAIGNS_LIST);
        //   return;
        // }

        setEditData({
          ...editData,
          status: payload.status,
          name: payload.name,
          description: payload.description,
          start_date: payload.start_date
            ? momentTZ.tz(`${payload.start_date} ${payload.start_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().toDate()
            : "",
          end_date: payload.end_date
            ? momentTZ.tz(`${payload.end_date} ${payload.end_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().toDate()
            : "",

          start_time: payload.end_date && payload.end_time
            ? momentTZ.tz(`${payload.start_date} ${payload.start_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().toDate()
            : "",
          end_time: payload.end_date && payload.end_time
            ? momentTZ.tz(`${payload.end_date} ${payload.end_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().toDate()
            : "",

          published_date: payload.published_date
            ? momentTZ.tz(`${payload.published_date} ${payload.published_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().toDate()
            : "",
          published_end_date: payload.published_end_date
            ? momentTZ.tz(`${payload.published_end_date} ${payload.published_end_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().toDate()
            : "",

          published_time: payload.published_date && payload.published_time
            ? momentTZ.tz(`${payload.published_date} ${payload.published_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().toDate()
            : "",
          published_end_time: payload.published_end_date && payload.published_end_time
            ? momentTZ.tz(`${payload.published_end_date} ${payload.published_end_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().toDate()
            : "",

          images: payload.images.length > 0 ? [payload.images[0].key] : [''],
          images_url: payload.images.length > 0 ? [payload.images[0].url] : [''],
          type: payload.type,
          category: payload.category,
          reward_type: payload.reward_type,
          provider: payload.provider,
          provider_id: payload.provider_id,
          value: payload.value,
          approver_id: payload.approver_id,
          approver_name: payload.approver_name,
        });

        if (payload?.approver_id) {
          setSelectedCampaignApprover({ id: payload.approver_id, name: payload.approver_name });
        }

        setDisableInterchange(payload?.interchanges || []);
        setIsSubmitted(payload?.submitted || false);


        setCampaignCategory({ name: payload.category });
        setRewardType({ name: payload.reward_type });
        setRewardProvider({ name: payload.provider, pk: payload.provider_id });

        setLoading(false);

      });
    } else {
      setLoading(false);

    }
  };

  const downloadRequiredData = async (callback) => {
    setLoading(true);
    dispatch(fetchUserById(localStorage.getItem("username"))).then(
      async (result) => {
        dispatch(fetchAllProviderList());
        dispatch(fetchCampaignApprovers("nominee_approver")).then((res) => {
          setDefaultNomineeApproverCombo(res.payload.data);
          setNomineeApproverCombo(res.payload.data);
        });
        dispatch(fetchCampaignApprovers("campaign_approver")).then((res) => {
          setDefaultCampaignApproverCombo(res.payload.data);
          setCampaignApproverCombo(res.payload.data);
        });
        dispatch(fetchCampaignInterchange());
        dispatch(fetchCampaignConfig()).then((res) => {
          setMatrixModuleList(res.payload.data.modules);
          setCampaignTypeList(res.payload.data.campaign_type);
          setEditData({
            ...editData,
            type: res.payload.data.campaign_type[0].name,
          });
          getData();
        });
      }
    );
  };

  useEffect(() => {

    query.set("state", 0);
    setSelectedTab(0);

  }, [firstRequest])

  useEffect(() => {
    if (campaignCategory?.name && editData.type != "Predefined Task Based") {
      dispatch(fetchTemplateDownloadURL(campaignCategory?.name));
    }
  }, [campaignCategory])

  useEffect(() => {
    let depot_interchanges = [];
    interchange_list.forEach((i) => {
      const alreadyAdded = depot_interchanges.some((x) => x.id === i.id);
      const isDisabled = disabledInterchange.some((d) => d.id === i.id);

      if (!alreadyAdded && !isDisabled) {
        depot_interchanges.push(i);
      }
    });
    setInterchangeCombo(depot_interchanges);
  }, [interchange_list, disabledInterchange])



  useEffect(() => {
    downloadRequiredData();
  }, []);

  useEffect(() => {

    if (editData.type == "Predefined Task Based") {
      return;
    }
    if (!clickDate) {
      return;
    }
    const publishStartDateTime = moment(`${moment(editData.published_date).format("YYYY-MM-DD")} ${moment(editData.published_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();

    if (moment(publishStartDateTime).isValid()) {

      if (moment(publishStartDateTime).isSame(moment(), "day")) {
        setPublishStartEndDateErrorMessage("Published Start date cannot be today.");
        setShowPublishStartEndDateError(true);
      } else {
        // if (editData.end_date == "") {
        const endDateTime = moment(publishStartDateTime).subtract(7, "days");
        const startDateTime = moment(publishStartDateTime).subtract(21, "days");

        setEditData({
          ...editData,
          end_date: endDateTime.toDate(),
          end_time: endDateTime.toDate(),
          start_date: startDateTime.toDate(),
          start_time: startDateTime.toDate(),
        });
        // }

      }
    }
  }, [editData.published_date, clickDate])

  useEffect(() => {

    if (editData.type == "Predefined Task Based") {
      return;
    }
    if (!clickDate) {
      return;
    }
    const endDateTime = moment(`${moment(editData.end_date).format("YYYY-MM-DD")}T${moment(editData.end_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();

    if (moment(endDateTime).isValid()) {

      if (moment(endDateTime).isSame(moment(), "day")) {
        setPublishStartEndDateErrorMessage("End date cannot be today.");
        setShowPublishStartEndDateError(true);
      } else {
        // if (editData.start_date == "") {
        const startDateTime = moment(endDateTime).subtract(14, "days");
        setEditData({
          ...editData,
          start_date: startDateTime.toDate(),
          start_time: startDateTime.toDate(),
        });
        // }

      }
    }
  }, [editData.end_date, clickDate])


  useEffect(() => {
    if (editData.type != "" && id) {
      const selectedType = campaignTypeList.find(
        (type) => type.name === editData.type
      );
      setCampaignType(selectedType);
    }

  }, [campaignTypeList]);



  const backtoInformation = () => {
    query.set("state", 0);
    navigate(REWARDS_CAMPAIGNS_ADD + "?" + query.toString());
  };

  useEffect(() => {
    const { name, description, start_date, end_date, start_time, end_time } = editData;
    const hasValue = [name, description, start_date, end_date, start_time, end_time].some(
      (value) => value !== null && value !== ""
    );
    setIsEnableSaveAsDraft(hasValue);
  }, [editData]);


  const checkMandatoryFields = () => {
    setShowDateError(false);
    setShowPublishStartEndDateError(false);

    const { start_date, start_time, end_date, end_time, name, description, published_date,
      published_time,
      published_end_date,
      published_end_time,
      value

    } = editData;

    if (!start_date || !start_time || !end_date || !end_time || !name) {
      console.error("All date and time fields must be filled.");
      setShowRequiredFieldError(true);
      return true;
    }

    if (!name || selectedCampaignApprover == null || !published_date || !published_time) {
      console.error("All required fields must be filled.");
      setShowRequiredFieldError(true);
      return true;
    }

    if (editData.type != "Predefined Task Based") {
      if (value <= 0) {
        console.error("Please enter a valid Reward Amount. The amount must be greater than 0.");
        setErrorMessage("Please enter a valid Reward Amount. The amount must be greater than 0.");
        setShowError(true);
        return true;
      }

      if (
        Object.keys(campaignCategory).length === 0 ||
        campaignCategory.name === ""
      ) {
        console.error("All date and time fields must be filled.");
        setShowRequiredFieldError(true);
        return true;
      }

      if (
        Object.keys(rewardType).length === 0 ||
        rewardType.name === ""
      ) {
        console.error("All date and time fields must be filled.");
        setShowRequiredFieldError(true);
        return true;
      }

      if (
        Object.keys(rewardProvider).length === 0 ||
        rewardProvider.name === ""
      ) {
        console.error("All date and time fields must be filled.");
        setShowRequiredFieldError(true);
        return true;
      }

    }


    const startDateTime = moment(`${moment(start_date).format("YYYY-MM-DD")} ${moment(start_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();
    const endDateTime = moment(`${moment(end_date).format("YYYY-MM-DD")}T${moment(end_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();

    // if (endDateTime <= startDateTime) {
    //   setShowDateError(true);
    //   return true;
    // }

    const publishStartDateTime = moment(`${moment(published_date).format("YYYY-MM-DD")} ${moment(published_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();
    const publishEndDateTime = moment(`${moment(published_end_date).format("YYYY-MM-DD")}T${moment(published_end_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();

    if (moment(publishStartDateTime).isSame(moment(), "day")) {
      setPublishStartEndDateErrorMessage("Published Start date cannot be today.");
      setShowPublishStartEndDateError(true);
      return true;
    }

    if (editData.type == "Predefined Task Based") {
      if (publishStartDateTime > startDateTime) {
        setPublishStartEndDateErrorMessage("Start date cannot be earlier than the publish start date.")
        setShowPublishStartEndDateError(true);
        return true;
      }
    }





    if (editData.type != "Predefined Task Based") {
      if (publishStartDateTime <= endDateTime) {
        setPublishStartEndDateErrorMessage("Published Start Date and Time must not earlier than or same End Date and Time (Nomination).")
        setShowPublishStartEndDateError(true);
        return true;
      }
    } else {
      if (publishEndDateTime <= publishStartDateTime) {
        setShowDateError(true);
        return true;
      }
    }



    if (endDateTime < new Date()) {
      setPublishStartEndDateErrorMessage("End time has already passed. Please select a valid date and time.")
      setShowPublishStartEndDateError(true);
      return true;
    }


    if (!AdminPermssion && ValidatorPermssion && nomineeList.length == 0 && selected_tab != 0) {
      console.error("All date and time fields must be filled.");
      setShowRequiredFieldError(true);
      return true;
    }

    if (nomineeList.length > 0 && selectedApprover == null && doc) {
      setErrorMessage('Please choose approver')
      setShowError(true);
      return true;
    }

  };



  const handleSubmit = (isSaved, isSubmission) => {

    if (!isSaved) {
      if (checkMandatoryFields()) return;
    }

    setLoading(true);

    let updatedData = { ...editData };

    if (id) {  // Ensures id is neither null nor empty
      updatedData.id = id;
    }

    updatedData.value = parseFloat(editData.value);

    let start_date_time = moment(`${moment(editData.start_date).format("YYYY-MM-DD")} ${moment(editData.start_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();
    let end_date_time = moment(`${moment(editData.end_date).format("YYYY-MM-DD")} ${moment(editData.end_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();

    let published_date_time = moment(`${moment(editData.published_date).format("YYYY-MM-DD")} ${moment(editData.published_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();
    let published_end_date_time = moment(`${moment(editData.published_end_date).format("YYYY-MM-DD")} ${moment(editData.published_end_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();


    updatedData.start_date = momentTZ(start_date_time).tz("Asia/Singapore").format("YYYY-MM-DD");

    updatedData.end_date = momentTZ(end_date_time).tz("Asia/Singapore").format("YYYY-MM-DD");

    updatedData.start_time = momentTZ(start_date_time).tz("Asia/Singapore").format("hh:mmA");
    updatedData.end_time = momentTZ(end_date_time).tz("Asia/Singapore").format("hh:mmA");


    updatedData.published_date = momentTZ(published_date_time).tz("Asia/Singapore").format("YYYY-MM-DD");
    updatedData.published_end_date = momentTZ(published_end_date_time).tz("Asia/Singapore").format("YYYY-MM-DD");


    updatedData.published_time = momentTZ(published_date_time).tz("Asia/Singapore").format("hh:mmA");
    updatedData.published_end_time = momentTZ(published_end_date_time).tz("Asia/Singapore").format("hh:mmA");

    updatedData.category = campaignCategory.name;
    updatedData.reward_type = rewardType.name;
    updatedData.provider = rewardProvider.name;
    updatedData.provider_id = rewardProvider.pk;
    updatedData.approver_id = selectedCampaignApprover?.id || '';
    updatedData.approver_name = selectedCampaignApprover?.name || '';



    if (isSaved) {
      if (editData.status == 'Draft') {
        updatedData.status = editData.status;
      }
    } else if (!isSaved && editData.type == "Predefined Task Based") {
      updatedData.status = "Draft";
      if (isSubmission) {
        if (AdminPermssion) {
          updatedData.status = "Pending Approval";
        }
        else if (ApproverPermssion) {
          updatedData.status = "Approved";
        }
      }

    } else {

      if (AdminPermssion) {
        if (!isSaved && editData.status == 'Draft') {
          updatedData.status = "Pending Approval";
        }

        if (editData.status == 'Rejected') {
          updatedData.status = "Pending Approval";
        }


      }
      else if (ApproverPermssion) {
        updatedData.status = "Approved";
      }
      else if (ValidatorPermssion) {
        updatedData.status = "Pending Nomination";
      }

    }





    if ((editData.status === "Approved" || editData.status === "Pending Nomination") && ValidatorPermssion && !AdminPermssion) {
      if (nomineeList.length > 0) {
        let nomineeData = {
          nominees: nomineeList,
          approver_id: selectedApprover?.id || '',
          approver_name: selectedApprover?.name || '',
          selected_interchange: selectedInterchange
        }
        dispatch(saveNominees({ data: nomineeData, id })).then((res) => {
          const { payload } = res;
          if (payload.status === "success") {
            navigate(REWARDS_CAMPAIGNS_LIST);
          } else {
            setLoading(false);
          }
        });
      } else {
        navigate(REWARDS_CAMPAIGNS_LIST);
      }
    } else {
      dispatch(createAndUpdateCampaign({ data: updatedData, id })).then((res) => {
        const { payload } = res;
        if (payload.status === "success") {
          const saved_id = payload.data?.id || id;
          getData();

          setLoading(false);


          if (selected_tab == 0 && editData.type == "Predefined Task Based") {
            let tab = parseInt(selected_tab) + 1;
            setSelectedTab(tab);
            setId(saved_id);
            query.set("id", saved_id);

          } else if (selected_tab == 2) {
            // if (nomineeList.length > 0 && editData.status === "Rejected" && AdminPermssion) {
            //   let nomineeData = {
            //     nominees: nomineeList,
            //     approver_id: selectedApprover?.id || '',
            //     approver_name: selectedApprover?.name || '',
            //     selected_interchange: selectedInterchange
            //   }
            //   dispatch(saveNominees({ data: nomineeData, id })).then((res) => {
            //     const { payload } = res;
            //     if (payload.status === "success") {
            //       navigate(REWARDS_CAMPAIGNS_LIST);
            //     } else {
            //       setLoading(false);
            //     }
            //   });
            // } else {
            //   navigate(REWARDS_CAMPAIGNS_LIST);
            // }
            navigate(REWARDS_CAMPAIGNS_LIST);


          } else {

            if (isSaved) {
              setSaveDraftMessage("Draft saved successfully.")
              setShowSaveDraftDialog(true);
              setLoading(false);

            } else {

              let tab = isSaved ? selected_tab : parseInt(selected_tab) + 1;
              setSelectedTab(tab);
              setId(saved_id);
              if (saved_id) {
                query.set("id", saved_id);
              }
              query.set("state", tab);
              navigate(REWARDS_CAMPAIGNS_ADD + "?" + query.toString());
            }
          }



        } else {
          setLoading(false);

          if (isSaved) {
            setSaveDraftMessage(res.message)
            setShowSaveDraftDialog(true);
          } else {
            setErrors(res.message);

          }

        }
      });
    }




  };

  const handleCloseDialog = () => {
    setShowSaveDraftDialog(false);
    navigate(REWARDS_CAMPAIGNS_LIST);
  };

  const isShowNominationTab = () => {

    let isShow = false;

    if ((editData.status == "Pending Nomination" || editData.status == "Approved") && !AdminPermssion && ValidatorPermssion) {
      isShow = true;
    }

    // if (editData.status == "Rejected" && AdminPermssion) {
    //   isShow = true;
    // }


    return isShow;
  };

  const isShowRewardConfigurationTab = () => {

    let isShow = false;

    if (editData.type == "Predefined Task Based") {
      isShow = true;
    }


    return isShow;
  };


  const handleNext = () => {

    if (checkMandatoryFields()) return;


    let tab = parseInt(selected_tab) + 1;

    if (id && isShowNominationTab()) {
      setSelectedTab(tab);
      setId(id);
      query.set("id", id);

    } else if (isShowRewardConfigurationTab()) {

      if (!id) {
        handleSubmit(false, false);
      } else if (selected_tab == 1) {
        if (rewardConfigurationList.length == 0) {
          alert("Please add at least one reward configuration.");
        } else {
          setSelectedTab(tab);
          setId(id);
          query.set("id", id);
        }
      } else {
        setSelectedTab(tab);
        setId(id);
        query.set("id", id);
      }

    } else {

      if (parseInt(selected_tab) == 0) {
        tab = 2;
      }
      setSelectedTab(tab);
      setId(id);
    }
    query.set("state", tab);
    navigate(REWARDS_CAMPAIGNS_ADD + "?" + query.toString());
  };

  const callback_handleBackBtn = (e) => {

    if (parseInt(selected_tab) === 0) {
      navigate(REWARDS_CAMPAIGNS_LIST);
      return;
    }

    let currentTab = selected_tab > 0 ? (selected_tab - 1) : 0;

    if (id) {
      query.set("id", id);
    }
    if (selected_tab == 2 && !isShowNominationTab() && !isShowRewardConfigurationTab()) {
      currentTab = 0;
    }
    query.set("state", currentTab);

    setSelectedTab(currentTab);
    navigate(REWARDS_CAMPAIGNS_ADD + "?" + query.toString());
  };


  const compareDate = (data) => {
    if (
      new Date(
        `${data.start_date} ${moment(data.start_time, "hh:mmA").format(
          "HH:mm:ss"
        )}`
      ) <
      new Date(
        `${data.end_date} ${moment(data.end_time, "hh:mmA").format("HH:mm:ss")}`
      )
    ) {
      return true;
    } else {
      return false;
    }
  };

  const uploadFile = () => {

    FileRef.current.click();
  };

  const docUpload = () => {
    if (selectedInterchange.length > 0) {
      DocRef.current.click();
    } else {
      setErrorMessage("Please select a Section / Interchange Group before uploading the file.")
      setShowError(true);
    }
  };

  function getFilePath(path) {
    const match = path.match(/https:\/\/[^/]+\/(.+?)\?/);
    return match ? match[1] : path;
  }

  const ImageHandler = () => {
    let url =
      id
        ? file === ""
          ? editData.images_url[0] !== "" && editData.images_url[0]
          : URL.createObjectURL(file)
        : file !== "" && URL.createObjectURL(file);
    let name =
      id
        ? file === ""
          ? editData.images_url[0] !== "" && editData.images_url[0].split("/")[5].split("?")[0]
          : file.name
        : file !== "" && file.name;
    return (
      <div className="campaigns_create_file_main_box">
        <div className="campaigns_create_file_child_box">
          <div>
            <img src={url} className="campaigns_create_file_image" />
          </div>
          <div className="campaigns_create_file_child_box_text">{name}</div>
        </div>
        <div>
          {AdminPermssion && (<span
            class="k-icon k-font-icon k-i-delete campaigns_create_file_child_box_delete_icon"
            onClick={() => {
              setFile("");
              setEditData({
                ...editData,
                images: [""],
                images_url: [""]
              });
            }}
          />
          )}

        </div>
      </div>
    );
  };


  const onUploadFile = async (e) => {
    setImageLoading(true);
    const token = await getCurrentLoggedInSessionTokenWithPromise();
    const extension_ =
      e.type === "" ? e.name.split(".")[1] : e.type.split("/")[1];
    api
      .post(
        CAMPAIGN_IMAGE_UPLOAD_ENDPOINT,
        JSON.stringify({
          extensions: [extension_],
        }),
        token
      )
      .then((res) => {
        api.postDiff(res.data[0].presigned_url, e).then((res1) => {
          console.log(res1);
          if (res1 === 200) {
            setFile(e);
            setEditData({
              ...editData,
              images: [res.data[0].key],
            });
            setImageLoading(false);
          } else {
            alert("An error occured while uploading file! Please try again!");
          }
        });
      });
  };


  const mimeToExtension = {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    "application/pdf": "pdf",
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/gif": "gif",
  };


  const onUploadDoc = async (e) => {
    setImageLoading(true);

    const token = await getCurrentLoggedInSessionTokenWithPromise();
    const extension_ = e.type
      ? mimeToExtension[e.type] || e.type.split("/")[1]
      : e.name.split(".").pop();
    api
      .post(
        `${CAMPAIGN_FILE_UPLOAD_ENDPOINT}/${id}/get-presigned-url`,
        JSON.stringify({
          extension: extension_,
        }),
        token
      )
      .then((res) => {
        api.postDiff(res.data.presigned_url, e).then((res1) => {
          if (res1 === 200) {
            api
              .post(
                `${CAMPAIGN_ENDPOINT}/${id}/nominees/preview`,
                JSON.stringify({
                  file_path: res.data.key,
                  selected_interchange: selectedInterchange,
                  approver_id: selectedApprover?.id || '',
                  approver_name: selectedApprover?.name || '',
                }),
                token
              ).then((res) => {
                setNomineeList(res.data.data);
                setInvalidNomineeList(res.data.invalid_user);
                setShowInvalidNomineeDialog(res.data.invalid_user.length > 0);
                setDoc(e);
                setImageLoading(false);
              })
              .catch((error) => {
                console.error("Error fetching nominees:", error);
                alert("Oops! Something’s not right with your file. Please make sure all required fields are filled and the data is in the correct format.");
                setImageLoading(false);
              });
          } else {
            alert("An error occured while uploading file! Please try again!");
          }
        });
      });
  };



  const DocHandler = () => {


    let name =
      id
        ? doc.name
        : doc !== "" && doc.name;
    return (
      <div className="campaigns_create_file_main_box">
        <div className="campaigns_create_file_child_box">
          <div className="campaigns_document_container">
            <Icon className="campaigns_document_icon">
              <img alt="" src={Docfile} />
            </Icon>
            <div className="campaigns_document_text">{name}</div>

          </div>
        </div>
        <div>
          <span
            class="k-icon k-font-icon k-i-delete campaigns_create_file_child_box_delete_icon"
            onClick={() => {
              setDoc("");
            }}
          />
        </div>
      </div>
    );

  };

  function getCampaignLabel(categoryName) {
    switch (categoryName) {
      case "FMP":
        return "FMP Commendations";
      case "Cares":
        return "Cares";
      case "Event":
        return "Event";
      case "HIRS":
        return "HIRS";
      default:
        return categoryName;
    }
  }



  const RenderRow = ({ title, value, isImage }) => {
    return (
      <>
        {value ? (
          <>
            <div className="campaigns_detail_child_box_main_detail_items">
              <div className="campaigns_detail_child_box_main_detail_items_title campaigns_detail_center_item detail_padding_bottom">
                {title}
              </div>
              <div className="campaigns_detail_child_box_main_detail_items_splitter" />
              <div className="campaigns_detail_center_item campaigns_detail_child_box_main_detail_items_subdetail detail_padding_bottom">
                {isImage ? (
                  <>
                    <img
                      style={{ height: "200px" }}
                      src={value}
                    />
                  </>
                ) : (
                  <>
                    <div dangerouslySetInnerHTML={{ __html: value }} />
                  </>
                )}
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </>
    );
  };

  const getEndDateTime = () => {
    if (!editData.end_date || !editData.end_time) return null;

    const dateTime = moment(`${moment(editData.end_date).format("YYYY-MM-DD")} ${moment(editData.end_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();

    return dateTime.isValid() ? dateTime.toDate() : null;
  };


  const filterChangeApprover = (event) => {

    // Extract typed text safely
    const filterText = String(event.filter?.value ?? '').toLowerCase();

    const filtered = defaultNomineeApproverCombo.filter(item => {
      const idStr = String(item.id).toLowerCase();
      const nameStr = (item.name || '').toLowerCase();
      return idStr.includes(filterText) || nameStr.includes(filterText);
    });

    setNomineeApproverCombo(filtered);
  };

  const filterChangeCampaignApprover = (event) => {

    // Extract typed text safely
    const filterText = String(event.filter?.value ?? '').toLowerCase();

    const filtered = defaultCampaignApproverCombo.filter(item => {
      const idStr = String(item.id).toLowerCase();
      const nameStr = (item.name || '').toLowerCase();
      return idStr.includes(filterText) || nameStr.includes(filterText);
    });

    setCampaignApproverCombo(filtered);
  };

  const handleChangeApprover = (event) => {
    // The selected value is in event.value
    setSelectedApprover(event.target.value);
    console.log("Selected value:", event.target.value);
  };

  const handleChangeCampaignApprover = (event) => {
    // The selected value is in event.value
    setSelectedCampaignApprover(event.target.value);
    console.log("Selected value:", event.target.value);
  };

  const onFilterChange = (e) => {
    setFilter(e.filter.value);
  };

  useEffect(() => {
    filterChangeInterchange(filter);
  }, [filter]);


  const filterChangeInterchange = (value) => {
    // Extract typed text safely
    const filterText = String(value ?? '').toLowerCase();

    const filtered = interchange_list.filter(item => {
      const idStr = String(item.id).toLowerCase();
      const nameStr = (item.name || '').toLowerCase();
      return idStr.includes(filterText) || nameStr.includes(filterText);
    });

    let depot_interchanges = [];
    filtered.forEach((i) => {
      const alreadyAdded = depot_interchanges.some((x) => x.id === i.id);
      const isDisabled = disabledInterchange.some((d) => d.id === i.id);

      if (!alreadyAdded && !isDisabled) {
        depot_interchanges.push(i);
      }
    });

    setInterchangeCombo(depot_interchanges);
  };

  const handleChangeInterchange = (event) => {
    // The selected value is in event.value
    setSelectedInterchange(event.value);
    console.log("Selected value:", event.target.value);
    setFilter("");
  };

  const toggleItem = (item) => {
    const exists = selectedInterchange.some((sel) => sel.id === item.id);
    if (exists) {
      setSelectedInterchange(selectedInterchange.filter((sel) => sel.id !== item.id));
    } else {
      setSelectedInterchange([...selectedInterchange, item]);
    }
    setFilter("");

  };


  const handleAddMore = () => {
    if (!rewardConfigurationTemp.module_code) return; // basic guard
    const isValid = Object.values(rewardConfigurationTemp).every(
      (val) => val && val.toString().trim() !== ""
    );

    if (!isValid) {
      console.log("All fields are mandatory");
      alert("All fields are mandatory");
      return;
    }
    setLoading(true);
    dispatch(createCampaignMatrix({ data: rewardConfigurationTemp, id })).then((res) => {
      const { payload } = res;
      if (payload.status === "success") {
        reloadMatrixList();
        // reset input row
        setRewardConfigurationTemp({
          module_name: "",
          module_code: "",
          point: "",
          limit: "",
          threshold: "",
          task_description: "",
          popup_message: "",
        });
      } else {
        setLoading(false);
      }
    });


  };


  useEffect(() => {
    if (rewardConfigurationList.length == 0 && editData.type == "Predefined Task Based") {
      reloadMatrixList();
    }
  }, [id])

  const reloadMatrixList = () => {
    setLoading(true);
    dispatch(fetchCampaignMatrixList(id)).then((res) => {
      const matrixList = res?.payload.data ?? []; // ✅ fallback to empty array

      setRewardConfigurationList(matrixList);

      setMatrixModuleList(prevModules => {
        // get module names from API
        const existingModules = new Set(
          matrixList.map(item => item.module_name)
        );

        // filter only modules NOT in API
        const filteredModules = prevModules.filter(
          module => !existingModules.has(module.name)
        );

        return filteredModules;
      });
      setLoading(false);

    });
  }


  const handleRowAction = (action, module_code) => {
    if (action === "Save") {
      const item = rewardConfigurationList.find(i => i.module_code === module_code);



      dispatch(updateCampaignMatrix({ data: item, id })).then((res) => {
        const { payload } = res;
        if (payload.status === "success") {
          reloadMatrixList();
        }
      });
    }

    if (action === "Delete") {
      const item = rewardConfigurationList.find(i => i.module_code === module_code);


      dispatch(deleteCampaignMatrixByModule({ module_code: item.module_code, id: id })).then((res) => {
        const { payload } = res;
        if (payload.status === "success") {
          reloadMatrixList();
        }
      });
    }
  };

  const handleTempListChange = (index, field, value) => {
    setRewardConfigurationList(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [field]: value,
      };
      return updated;
    });
  };


  const getSortIcon = () => {
    return <Icon>
      <img alt="" src={UnsortIcon} />
    </Icon>;
  };

  const renderRewardConfiguration = () => {


    return <div className="campaigns_reward_configuration_create_scroll_box">
      <div className="table-wrapper">
        <table className="reward-configuration-table">
          <thead>
            <tr>
              <th width="120px">
                Module {getSortIcon()}
              </th>

              <th width="110px">
                No. of Submission {getSortIcon()}
              </th>

              <th width="110px">
                Reward Points  {getSortIcon()}
              </th>

              <th >
                Earning Limit {getSortIcon()}
              </th>

              <th >
                Task description {getSortIcon()}
              </th>

              <th >
                Popup message {getSortIcon()}
              </th>

              <th >
                Action {getSortIcon()}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <DropDownList
                  data={matrixModuleList}
                  value={{ "name": rewardConfigurationTemp.module_name, "code": rewardConfigurationTemp.module_code }}
                  dataItemKey="code"
                  textField="name"
                  disabled={!AdminPermssion}
                  size={"large"}
                  onChange={(e) => {

                    setRewardConfigurationTemp({
                      ...rewardConfigurationTemp,
                      module_name: e.target.value.name,
                      module_code: e.target.value.code,
                    })
                  }}
                  iconColor="#73007D"
                  iconClassName="k-icon k-font-icon k-i-arrow-chevron-down"
                  className="reward-configuration-table-dropdown"

                />
              </td>

              <td>
                <TextBox
                  className="campaigns_create_item_main_box_field"
                  value={rewardConfigurationTemp.threshold}
                  disabled={!AdminPermssion}
                  inputMode="decimal"
                  pattern="^[0-9]*[.,]?[0-9]*$"
                  onChange={(e) =>
                    setRewardConfigurationTemp({
                      ...rewardConfigurationTemp,
                      threshold: e.target.value,
                    })
                  }
                />
              </td>
              <td>
                <TextBox
                  className="campaigns_create_item_main_box_field"
                  value={rewardConfigurationTemp.point}
                  disabled={!AdminPermssion}
                  inputMode="decimal"
                  pattern="^[0-9]*[.,]?[0-9]*$"
                  onChange={(e) =>
                    setRewardConfigurationTemp({
                      ...rewardConfigurationTemp,
                      point: e.target.value,
                    })
                  }
                />
              </td>
              <td>
                <div className="reward-configuration-table-earning-limit-div">
                  {
                    (rewardConfigurationTemp.limit != "unlimited" && rewardConfigurationTemp.limit != "") && (
                      <div style={{ alignSelf: "center" }}>
                        Per
                      </div>
                    )
                  }


                  <DropDownList
                    data={matrixLimitList}
                    value={matrixLimitList.find(item => item.code === rewardConfigurationTemp.limit) || null}
                    disabled={!AdminPermssion}
                    size={"large"}
                    dataItemKey="code"
                    textField="name"
                    onChange={(e) => {

                      setRewardConfigurationTemp({
                        ...rewardConfigurationTemp,
                        limit: e.target.value.code,
                      })
                    }}
                    iconColor="#73007D"
                    iconClassName="k-icon k-font-icon k-i-arrow-chevron-down"
                    className="reward-configuration-table-dropdown"
                  />
                </div>

              </td>
              <td>
                <TextArea
                  className="campaigns_create_item_main_box_field"
                  value={rewardConfigurationTemp.task_description}
                  disabled={!AdminPermssion}
                  style={{ "borderRadius": "5px", minHeight: "70px" }}
                  onChange={(e) =>
                    setRewardConfigurationTemp({
                      ...rewardConfigurationTemp,
                      task_description: e.target.value,
                    })
                  }
                />
              </td>

              <td>
                <TextArea
                  className="campaigns_create_item_main_box_field"
                  value={rewardConfigurationTemp.popup_message}
                  disabled={!AdminPermssion}
                  style={{ "borderRadius": "5px", minHeight: "70px" }}
                  onChange={(e) =>
                    setRewardConfigurationTemp({
                      ...rewardConfigurationTemp,
                      popup_message: e.target.value,
                    })
                  }
                />
              </td>

              <td>
                <div>
                  <div
                    className="reward-configuration-add-more-button"

                    onClick={handleAddMore}
                  >
                    + Add More
                  </div>


                </div>

              </td>
            </tr>


            {rewardConfigurationList.map((item, index) => (
              <tr>
                <td>
                  <DropDownList
                    data={matrixModuleList}
                    value={{ "name": item.module_name, "code": item.module_code }}
                    dataItemKey="code"
                    textField="name"
                    disabled={!AdminPermssion}
                    size={"large"}
                    onChange={(e) => {

                      handleTempListChange(index, "module_name", e.target.value.name)
                      handleTempListChange(index, "module_code", e.target.value.code)

                    }}
                    iconColor="#73007D"
                    iconClassName="k-icon k-font-icon k-i-arrow-chevron-down"
                    className="reward-configuration-table-dropdown"

                  />
                </td>

                <td>
                  <TextBox
                    className="campaigns_create_item_main_box_field"
                    value={item.threshold}
                    disabled={!AdminPermssion}
                    inputMode="decimal"
                    pattern="^[0-9]*[.,]?[0-9]*$"
                    onChange={(e) =>
                      handleTempListChange(index, "threshold", e.target.value)

                    }
                  />
                </td>
                <td>
                  <TextBox
                    className="campaigns_create_item_main_box_field"
                    value={item.point}
                    disabled={!AdminPermssion}
                    inputMode="decimal"
                    pattern="^[0-9]*[.,]?[0-9]*$"
                    onChange={(e) =>
                      handleTempListChange(index, "point", e.target.value)

                    }
                  />
                </td>
                <td>
                  <div className="reward-configuration-table-earning-limit-div">
                    {
                      (item.limit.toLowerCase() != "unlimited" && item.limit != "") && (
                        <div style={{ alignSelf: "center" }}>
                          Per
                        </div>
                      )
                    }


                    <DropDownList
                      data={matrixLimitList}
                      value={matrixLimitList.find(res => res.code === item.limit) || null}
                      disabled={!AdminPermssion}
                      dataItemKey="code"
                      textField="name"
                      size={"large"}
                      onChange={(e) => {

                        handleTempListChange(index, "limit", e.target.value.code)

                      }}
                      iconColor="#73007D"
                      iconClassName="k-icon k-font-icon k-i-arrow-chevron-down"
                      className="reward-configuration-table-dropdown"
                    />
                  </div>

                </td>
                <td>
                  <TextArea
                    className="campaigns_create_item_main_box_field"
                    value={item.task_description}
                    disabled={!AdminPermssion}
                    style={{ "borderRadius": "5px", minHeight: "70px" }}
                    onChange={(e) =>
                      handleTempListChange(index, "task_description", e.target.value)

                    }
                  />
                </td>

                <td>
                  <TextArea
                    className="campaigns_create_item_main_box_field"
                    value={item.popup_message}
                    disabled={!AdminPermssion}
                    style={{ "borderRadius": "5px", minHeight: "70px" }}
                    onChange={(e) =>
                      handleTempListChange(index, "popup_message", e.target.value)
                    }
                  />
                </td>

                <td>
                  <div>

                    <DropDownList
                      data={["Save", "Delete"]}
                      value={"Actions"}
                      disabled={!AdminPermssion}
                      size={"large"}
                      onChange={(e) => {
                        handleRowAction(e.target.value, item.module_code);
                      }}
                      style={{
                        fontSize: "15px",
                        width: "120px",
                        height: "48px",
                        backgroundColor: "#EB6E1F",
                        color: "white",
                        textAlign: "center",
                        borderRadius: "8px",
                      }}
                    />
                  </div>

                </td>
              </tr>
            ))}

          </tbody>
        </table>
      </div>
    </div>;
  }



  return (
    <>
      {((!id && AddPermssion) || UploadExcelPermssion || (editData.status == "Pending Approval" && id && ApproverPermssion && getEndDateTime() >= new Date() && localStorage.getItem("username") == editData.approver_id) || (editData.status == "Approved" && ValidatorPermssion && !AdminPermssion && nomineeList.length == 0) || ((editData.status != "Published" && editData.status != "Scheduled" && editData.status != "Approved") && AdminPermssion)) ? (
        <div style={{ height: "calc(100% - 75px)" }}>

          {errors && (
            <Dialog
              width={400}
              title={"Message"}
              onClose={() => setErrors(false)}
              className="error-message"
            >
              <p>{errors}</p>
            </Dialog>
          )}

          {showRequiredFieldError && (
            <Dialog
              className="information-details-alert-form"
              title={"Alert"}
              onClose={() => setShowRequiredFieldError(false)}
            >
              <p
                style={{
                  margin: "25px",
                  textAlign: "center",
                }}
              >
                Please fill in all the required fields.
              </p>
            </Dialog>
          )}

          {imageLoading && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 76px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}

          {(loading || template_download_loading) && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 75px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}

          <AddCampaignHeader
            backBtncallback={(e) => callback_handleBackBtn(e)}
            state={selected_tab}
          />
          <AddCampaignSteps
            state={selected_tab}
            setState={setSelectedTab}
            checkMandatoryFields={checkMandatoryFields}
            handleSubmit={handleSubmit}
            editData={editData}
            isAdmin={AdminPermssion}
            isValidator={ValidatorPermssion}
          />

          <div className="main-poll-survey-container">
            <div className="main-poll-survey">
              {
                selected_tab == 0 ? (
                  <div className="campaigns_create_scroll_box">
                    <div>
                      <div className="campaigns_create_item_main_box">
                        <div className="campaigns_create_item_main_box_title">
                          Campaign Name <span style={{ color: "red" }}>*</span>
                        </div>
                        <div>
                          <TextBox
                            className="campaigns_create_item_main_box_field"
                            value={editData.name}
                            disabled={!AdminPermssion}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                name: e.target.value,
                              })
                            }
                          />
                          {error.name !== "" && (
                            <div className="campaigns_create_error_text">
                              {error.name}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="campaigns_create_item_main_box">
                        <div className="campaigns_create_item_main_box_title">
                          Campaign Description
                        </div>
                        <div>
                          <TextBox
                            className="campaigns_create_item_main_box_field"
                            value={editData.description}
                            disabled={!AdminPermssion}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                description: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>

                      <div className="campaigns_create_item_main_box">
                        <div className="campaigns_main_box_title">Campaign Approver <span style={{ color: "red" }}>*</span></div>
                        <div>
                          <ComboBox
                            id="campaign_approver"
                            data={campaignApproverCombo}
                            textField="name"
                            dataItemKey="id"
                            disabled={!AdminPermssion}

                            filterable={true}
                            onFilterChange={filterChangeCampaignApprover}
                            style={{
                              width: '100%'
                            }}
                            onChange={handleChangeCampaignApprover}
                            value={selectedCampaignApprover}
                            placeholder="Choose Campaign Approver"
                            itemRender={(li, itemProps) => {
                              const item = itemProps.dataItem || {}
                              const id = item.id ?? '-'
                              const name = item.name?.trim() ? item.name : '-'
                              return React.cloneElement(li, li.props, `${name} (${id})`)
                            }}

                          />
                        </div>
                      </div>

                      <div className="campaigns_create_item_main_box">
                        <div className="campaigns_create_upload_main_box">
                          <div className="campaigns_create_item_main_box_title">
                            Image Upload
                            <span className="campaigns_create_item_main_box_title_span">
                              (Max 1 file, no more than 5MB each)
                            </span>
                          </div>
                        </div>
                        {!file && editData.images[0] === "" && (<div className="campaigns_nodata_view margin-bottom">
                          <div className="campaigns_nodata_title"> No image</div>
                          {AdminPermssion && (
                            <div className="campaigns_create_upload_button_box">
                              <div onClick={uploadFile} >
                                <div>+ Upload Image</div>
                                <input
                                  accept={[
                                    "image/jpeg",
                                    "image/png",
                                    "image/jpg",
                                    //   "application/pdf",
                                    //   "application/msword",
                                  ]}
                                  ref={FileRef}
                                  type="file"
                                  hidden
                                  onClick={(e) => (e.target.value = "")}
                                  onChange={(e) => onUploadFile(e.target.files[0])}
                                />
                              </div>
                            </div>
                          )}
                        </div>)}
                        {id
                          ? editData.images[0] !== "" && <ImageHandler />
                          : file !== "" && <ImageHandler />}
                      </div>


                      <div className="campaigns_create_item_main_box">
                        <div className="campaigns_create_item_main_box_title">
                          Campaign Type <span style={{ color: "red" }}>*</span>
                        </div>
                        <div className="campaigns_add_dropdown margin-bottom">
                          <DropDownList
                            data={config_list ? config_list.campaign_type : []}
                            value={campaignType}
                            dataItemKey="name"
                            textField="name"
                            disabled={!AdminPermssion}
                            size={"large"}
                            onChange={(e) => {

                              setEditData({
                                ...editData,
                                type: e.target.value.name,
                              })
                              setCampaignType(e.target.value);
                            }}
                            iconColor="#73007D"
                            iconClassName="k-icon k-font-icon k-i-arrow-chevron-down"
                          />
                          {error.category !== "" && (
                            <div className="campaigns_create_error_text">
                              {error.category}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="campaigns_date_layout">
                        <div className="campaigns_main_box margin-bottom">
                          <div className="campaigns_main_box_title">Start Date {editData.type != "Predefined Task Based" ? "(Nomination)" : ""} <span style={{ color: "red" }}>*</span></div>
                          <div>
                            <DatePicker
                              dateFormatCalendar="MMMM"
                              className="poll-survey-date-picker"
                              selected={editData.start_date}
                              disabled={!AdminPermssion}
                              dateFormat="dd/MM/yyyy"

                              minDate={new Date()}
                              onChange={(date) => {
                                setEditData((prevData) => ({
                                  ...prevData,
                                  start_date: date,
                                }));
                              }}
                              customInput={<CustomDatePicker disabled={!AdminPermssion} />}
                            />
                          </div>
                          {editData.type != "Predefined Task Based" ?
                            <span className="campaign-publish-date-warning">Auto-filled 21 days before Publish/Scheduled Date</span>
                            : <></>}

                        </div>

                        <div className="campaigns_main_box margin-bottom">
                          <div className="campaigns_main_box_title">Start Time {editData.type != "Predefined Task Based" ? "(Nomination)" : ""} <span style={{ color: "red" }}>*</span></div>
                          <div>
                            <TimePicker
                              placeholder={""}
                              className="info-datetime-picker keyboardInputDisable"
                              defaultValue={editData.start_time}
                              value={editData.start_time}
                              disabled={!AdminPermssion}

                              // min={""}
                              min={
                                editData.start_date === ""
                                  ? minMinute
                                  : moment(editData.start_date).format("DD-MM-YYYY") ===
                                    moment(new Date()).format("DD-MM-YYYY")
                                    ? minMinute
                                    : undefined
                              }
                              steps={{
                                hour: 1,
                                minute: 1,
                                // second: 30,
                              }}
                              onChange={(e) => {

                                setEditData((prevData) => ({
                                  ...prevData,
                                  start_time: e.target.value,
                                }));
                              }}
                            // required
                            />
                          </div>
                        </div>

                      </div>


                      <div className="campaigns_date_layout ">
                        <div className="campaigns_main_box  margin-bottom">
                          <div className="campaigns_main_box_title">End Date {editData.type != "Predefined Task Based" ? "(Nomination)" : ""} <span style={{ color: "red" }}>*</span></div>
                          <div>
                            <DatePicker
                              dateFormatCalendar="MMMM"
                              selected={editData.end_date}
                              className="poll-survey-date-picker"
                              minDate={new Date()}
                              disabled={!AdminPermssion}
                              dateFormat="dd/MM/yyyy"

                              onChange={(date) => {
                                setEditData((prevData) => ({
                                  ...prevData,
                                  end_date: date,
                                }));
                                setClickDate(true);
                              }}
                              customInput={<CustomDatePicker disabled={!AdminPermssion} />}
                            />
                          </div>
                          {editData.type != "Predefined Task Based" ?
                            <span className="campaign-publish-date-warning">Auto-filled 7 days before Publish/Scheduled Date</span>
                            : <></>}
                        </div>

                        <div className="campaigns_main_box">
                          <div className="campaigns_main_box_title">End Time {editData.type != "Predefined Task Based" ? "(Nomination)" : ""} <span style={{ color: "red" }}>*</span></div>
                          <div>
                            <TimePicker
                              placeholder={""}
                              className="info-datetime-picker keyboardInputDisable"
                              defaultValue={editData.end_time}
                              value={editData.end_time}
                              disabled={!AdminPermssion}

                              // min={""}
                              min={
                                editData.end_date === ""
                                  ? minMinute
                                  : moment(editData.end_date).format("DD-MM-YYYY") ===
                                    moment(new Date()).format("DD-MM-YYYY")
                                    ? minMinute
                                    : undefined
                              }
                              steps={{
                                hour: 1,
                                minute: 1,
                                // second: 30,
                              }}
                              onChange={(e) => {

                                setEditData((prevData) => ({
                                  ...prevData,
                                  end_time: e.target.value,
                                }));
                              }}
                            // required
                            />
                          </div>
                        </div>

                      </div>



                      <div className="campaigns_date_layout">
                        <div className="campaigns_main_box margin-bottom">
                          <div className="campaigns_main_box_title">Published/Scheduled Start Date <span style={{ color: "red" }}>*</span></div>
                          <div>
                            <DatePicker
                              dateFormatCalendar="MMMM"
                              className="poll-survey-date-picker"
                              selected={editData.published_date}
                              minDate={new Date()}
                              disabled={!AdminPermssion}
                              dateFormat="dd/MM/yyyy"

                              onChange={(date) => {
                                setEditData((prevData) => ({
                                  ...prevData,
                                  published_date: date,
                                }));
                                setClickDate(true);
                              }}
                              customInput={<CustomDatePicker disabled={!AdminPermssion} />}
                            />
                          </div>
                        </div>

                        <div className="campaigns_main_box margin-bottom">
                          <div className="campaigns_main_box_title">Published/Scheduled Start Time <span style={{ color: "red" }}>*</span></div>
                          <div>
                            <TimePicker
                              placeholder={""}
                              className="info-datetime-picker keyboardInputDisable"
                              defaultValue={editData.published_time}
                              value={editData.published_time}
                              disabled={!AdminPermssion}

                              // min={""}
                              min={
                                editData.published_date === ""
                                  ? minMinute
                                  : moment(editData.published_date).format("DD-MM-YYYY") ===
                                    moment(new Date()).format("DD-MM-YYYY")
                                    ? minMinute
                                    : undefined
                              }
                              steps={{
                                hour: 1,
                                minute: 1,
                                // second: 30,
                              }}
                              onChange={(e) => {

                                setEditData((prevData) => ({
                                  ...prevData,
                                  published_time: e.target.value,
                                }));
                              }}
                            // required
                            />
                          </div>
                        </div>

                      </div>


                      <div className="campaigns_date_layout margin-bottom">
                        <div className="campaigns_main_box">
                          <div className="campaigns_main_box_title">Published/Scheduled End Date</div>
                          <div>
                            <DatePicker
                              dateFormatCalendar="MMMM"
                              selected={editData.published_end_date}
                              className="poll-survey-date-picker"
                              minDate={new Date()}
                              disabled={!AdminPermssion}
                              dateFormat="dd/MM/yyyy"

                              onChange={(date) => {
                                setEditData((prevData) => ({
                                  ...prevData,
                                  published_end_date: date,
                                }));
                              }}
                              customInput={<CustomDatePicker disabled={!AdminPermssion} />}
                            />
                          </div>
                        </div>

                        <div className="campaigns_main_box">
                          <div className="campaigns_main_box_title">Published/Scheduled End Time</div>
                          <div>
                            <TimePicker
                              placeholder={""}
                              className="info-datetime-picker keyboardInputDisable"
                              defaultValue={editData.published_end_time}
                              value={editData.published_end_time}
                              disabled={!AdminPermssion}

                              // min={""}
                              min={
                                editData.published_end_date === ""
                                  ? minMinute
                                  : moment(editData.published_end_date).format("DD-MM-YYYY") ===
                                    moment(new Date()).format("DD-MM-YYYY")
                                    ? minMinute
                                    : undefined
                              }
                              steps={{
                                hour: 1,
                                minute: 2,
                                // second: 30,
                              }}
                              onChange={(e) => {

                                setEditData((prevData) => ({
                                  ...prevData,
                                  published_end_time: e.target.value,
                                }));
                              }}
                            // required
                            />
                          </div>
                        </div>

                      </div>




                      <div className="campaigns_create_item_main_box">
                        <div className="campaigns_create_item_main_box_title">
                          Campaign Category <span style={{ color: "red" }}>*</span>
                        </div>
                        <div className="campaigns_add_dropdown">
                          <DropDownList
                            data={config_list && config_list?.campaign_category && config_list?.campaign_category.length > 0  ? config_list.campaign_category : []}
                            value={campaignCategory}
                            dataItemKey="name"
                            disabled={!AdminPermssion}
                            textField="name"
                            size={"large"}
                            onChange={(e) => {
                              setEditData({
                                ...editData,
                                category: e.target.value.name,
                              })
                              setCampaignCategory(e.target.value);
                            }}
                            iconColor="#73007D"
                            iconClassName="k-icon k-font-icon k-i-arrow-chevron-down"
                          />
                          {error.category !== "" && (
                            <div className="campaigns_create_error_text">
                              {error.category}
                            </div>
                          )}
                        </div>
                      </div>


                      {
                        editData.type != "Predefined Task Based" && (
                          <>
                            <div className="campaigns_create_item_main_box">
                              <div className="campaigns_create_item_main_box_title">
                                Reward Type <span style={{ color: "red" }}>*</span>
                              </div>
                              <div className="campaigns_add_dropdown">
                                <DropDownList
                                  data={config_list ? config_list.reward_type : []}
                                  value={rewardType}
                                  dataItemKey="name"
                                  textField="name"
                                  size={"large"}
                                  disabled={!AdminPermssion}

                                  onChange={(e) => {
                                    setEditData({
                                      ...editData,
                                      reward_type: e.target.value.name,
                                    })
                                    setRewardType(e.target.value);
                                    setRewardProvider({})
                                  }}
                                  iconColor="#73007D"
                                  iconClassName="k-icon k-font-icon k-i-arrow-chevron-down"
                                />
                                {error.category !== "" && (
                                  <div className="campaigns_create_error_text">
                                    {error.category}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="campaigns_create_item_main_box">
                              <div className="campaigns_create_item_main_box_title">
                                Reward Provider <span style={{ color: "red" }}>*</span>
                              </div>
                              <div className="campaigns_add_dropdown">
                                <DropDownList
                                  data={provide_list && provide_list.length > 0 ? provide_list.filter((item) =>
                                    item.campaign_type
                                      .toLowerCase()
                                      .includes(rewardType.name?.toLowerCase() || "")) : []}
                                  value={rewardProvider}
                                  dataItemKey="pk"
                                  textField="name"
                                  size={"large"}
                                  disabled={!AdminPermssion}

                                  onChange={(e) => {
                                    setEditData({
                                      ...editData,
                                      provider: e.target.value.name,
                                      provider_id: e.target.value.pk,
                                    })
                                    setRewardProvider(e.target.value)
                                  }}
                                  iconColor="#73007D"
                                  iconClassName="k-icon k-font-icon k-i-arrow-chevron-down"
                                />
                                {error.category !== "" && (
                                  <div className="campaigns_create_error_text">
                                    {error.category}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="campaigns_create_item_main_box">
                              <div className="campaigns_create_item_main_box_title">
                                Amount of Each Reward (in $)
                              </div>
                              <div>
                                <TextBox
                                  inputMode="decimal"
                                  pattern="^[0-9]*[.,]?[0-9]*$"
                                  className="campaigns_create_item_main_box_field"
                                  value={editData.value}
                                  disabled={!AdminPermssion}
                                  onChange={(e) => {
                                    let val = e.target.value;

                                    // Allow only digits and one decimal point
                                    if (/^\d*\.?\d*$/.test(val)) {
                                      setEditData({
                                        ...editData,
                                        value: val,
                                      });
                                    }
                                  }}
                                />
                                {error.value !== "" && (
                                  <div className="campaigns_create_error_text">
                                    {error.value}
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        )
                      }



                    </div>
                  </div>
                ) : (<div></div>)
              }

              {
                (selected_tab == 1 && editData.type == "Predefined Task Based") &&
                (
                  renderRewardConfiguration()
                )
              }
              {

                (selected_tab == 1 && editData.type != "Predefined Task Based") ? (
                  <div className="campaigns_create_scroll_box">
                    <div>
                      {UploadExcelPermssion && (<div className="campaigns_create_item_main_box">

                        <div className="campaigns_date_layout">
                          <div className="campaigns_main_box">
                            <div className="campaigns_main_box_title">Section / Interchange Group {!AdminPermssion && ValidatorPermssion && (<span style={{ color: "red" }}>*</span>)}</div>
                            <div>
                              <MultiSelect
                                id="interchange"
                                data={interchangeCombo}
                                textField="name"
                                dataItemKey="id"
                                filterable={true}
                                filter={filter}
                                onFilterChange={onFilterChange}
                                style={{ width: "100%" }}
                                onChange={handleChangeInterchange}
                                value={selectedInterchange}
                                placeholder="Choose Section / Interchange Group"
                                itemRender={(li, itemProps) => {
                                  const item = itemProps.dataItem;
                                  const checked = selectedInterchange.some((sel) => sel.id === item.id);

                                  return (
                                    <div
                                      style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                                      onClick={(e) => {
                                        e.stopPropagation(); // prevent dropdown from closing
                                        toggleItem(item); // manually toggle selection
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={checked}
                                        readOnly
                                        style={{
                                          marginRight: 8,
                                          accentColor: checked ? "#73007D" : "#ccc"
                                        }}
                                      />
                                      <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div>{item.name} ({item.id})</div>
                                      </div>
                                    </div>
                                  );
                                }}
                              />

                            </div>
                          </div>

                          <div className="campaigns_main_box">
                            <div className="campaigns_main_box_title">Approver {!AdminPermssion && ValidatorPermssion && (<span style={{ color: "red" }}>*</span>)}</div>
                            <div>
                              <ComboBox
                                id="approver"
                                data={nomineeApproverCombo}
                                textField="name"
                                dataItemKey="id"
                                filterable={true}
                                onFilterChange={filterChangeApprover}
                                style={{
                                  width: '100%'
                                }}
                                onChange={handleChangeApprover}
                                value={selectedApprover}
                                placeholder="Choose Approver"
                                itemRender={(li, itemProps) => {
                                  const item = itemProps.dataItem || {}
                                  const id = item.id ?? '-'
                                  const name = item.name?.trim() ? item.name : '-'
                                  return React.cloneElement(li, li.props, `${name} (${id})`)
                                }}

                              />
                            </div>
                          </div>

                        </div>

                        <div className="campaigns-create-note">
                          {`Note: Each nominee can receive a maximum of 2 coupons per month, even if they have more than 2 ${getCampaignLabel(campaignCategory.name)}.`}
                        </div>
                        <div className="campaigns_create_upload_main_box">

                          <div className="campaigns_create_item_main_box_title">
                            Upload Excel File
                            <span className="campaigns_create_item_main_box_title_span">
                              (Max 1 file, no more than 5MB each) {!AdminPermssion && ValidatorPermssion && (<span style={{ color: "red" }}>*</span>)}
                            </span>
                          </div>



                          <div className="campaigns_download_template">
                            <Icon className="campaigns_download_template_icon">
                              <img alt="" src={DownloadIcon} />
                            </Icon>
                            <a href={template_download?.presigned_url} download={template_download?.filename} className="campaigns_download_template_text">
                              Download Template
                            </a>
                          </div>
                        </div>
                        {!doc && (<div className="campaigns_upload_view">
                          <div className="campaigns_nodata_title"> No nominees uploaded</div>
                          <div className="campaigns_create_upload_button_box">
                            <div onClick={docUpload}>
                              <div>+ Upload Excel</div>
                              <input
                                accept={[
                                  // "image/jpeg",
                                  // "image/png",
                                  // "image/jpg",
                                  "application/vnd.ms-excel",
                                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                ]}
                                ref={DocRef}
                                type="file"
                                hidden
                                onClick={(e) => (e.target.value = "")}
                                onChange={(e) => {

                                  if (selectedInterchange.length > 0) {
                                    if (nomineeList.length > 0 && isSubmitted) {
                                      setTempDoc(e.target.files[0])
                                      setShowUploadOverrideWarning(true)
                                    } else {
                                      onUploadDoc(e.target.files[0])
                                    }
                                  } else {
                                    setErrorMessage("Please select a Section / Interchange Group before uploading the file.")
                                    setShowError(true);
                                  }

                                }}
                              />
                            </div>
                          </div>


                        </div>)}
                        {id && doc && <DocHandler />}
                      </div>
                      )}
                      {
                        (!nomineeList || nomineeList.length === 0) ?
                          (<div className="campaigns_empty">
                            <Icon>
                              <img alt="" src={NoNominee} />
                            </Icon>
                            <div className="campaigns_empty_title"> No nominees uploaded</div>
                          </div>)
                          : (<NomineeSortableTable data={nomineeList} setData={setNomineeList} categoryName={getCampaignLabel(campaignCategory.name)} showAction={true} />)
                      }


                    </div>
                  </div>
                ) : (<div></div>)
              }


              {(selected_tab == 2 && Object.keys(editData).length > 0) && (
                <div className="campaigns_create_item_main_box">
                  <div className="campaigns_create_item_main_box_title">
                    Campaign Info
                  </div>
                  <div style={{ margin: "10px" }} className="margin-bottom">
                    <RenderRow
                      title={"Campaign Name"}
                      value={editData.name}
                      isImage={false}
                    />
                    <RenderRow
                      title={"Campaign Description"}
                      value={editData.description}
                      isImage={false}
                    />
                    <RenderRow
                      title={"Start Date & Time"}
                      value={`${moment(editData.start_date, "YYYY-MM-DD").format('DD-MM-YYYY')} ${moment(editData.start_time).format("hh:mm A")}`}
                      isImage={false}
                    />

                    <RenderRow
                      title={"End Date & Time"}
                      value={`${moment(editData.end_date, "YYYY-MM-DD").format('DD-MM-YYYY')} ${moment(editData.end_time).format("hh:mm A")}`}
                      isImage={false}
                    />

                    <RenderRow
                      title={"Published/Scheduled State Date & Time"}
                      value={`${moment(editData.published_date, "YYYY-MM-DD").format('DD-MM-YYYY')} ${moment(editData.published_time).format("hh:mm A")}`}
                      isImage={false}
                    />

                    <RenderRow
                      title={"Published/Scheduled End Date & Time"}
                      value={
                        editData?.published_end_date && editData?.published_end_time
                          ? `${moment(editData.published_end_date, "YYYY-MM-DD").format("DD-MM-YYYY")} ${moment(editData.published_end_time).format("hh:mm A")}`
                          : ""
                      }
                      isImage={false}
                    />

                    <RenderRow
                      title={"Campaign Type"}
                      value={editData.type}
                      isImage={false}
                    />
                    {
                      editData.type != "Predefined Task Based" && (
                        <>

                          <RenderRow
                            title={"Campaign Category"}
                            value={editData.category}
                            isImage={false}
                          />

                          <RenderRow
                            title={"Reward Type"}
                            value={editData.reward_type}
                            isImage={false}
                          />

                          <RenderRow
                            title={"Reward Provider"}
                            value={editData.provider}
                            isImage={false}
                          />

                          <RenderRow
                            title={"Amount of Each Reward (in $)"}
                            value={`${editData.value}`}
                            isImage={false}
                          />

                        </>
                      )}


                    <RenderRow
                      title={"Campaign Approver"}
                      value={`${selectedCampaignApprover?.name || ''}`}
                      isImage={false}
                    />

                    <RenderRow
                      title={"Uploaded image"}
                      value={
                        file
                          ? URL.createObjectURL(file)
                          : editData.images_url[0]
                            ? editData.images_url[0]
                            : ""
                      } isImage={true}
                    />
                  </div>

                  {
                    (editData.status == "Pending Nomination" || editData.status == "Approved") && (
                      <>
                        <div className="campaigns_create_item_main_box_title">
                          Nominees list
                        </div>
                        <div className="campaigns-create-note">
                          {`Note: Each nominee can receive a maximum of 2 coupons per month, even if they have more than 2 ${getCampaignLabel(campaignCategory.name)}.`}
                        </div>

                        {
                          (!nomineeList || nomineeList.length === 0) ?
                            (<div className="campaigns_empty">
                              <Icon>
                                <img alt="" src={NoNominee} />
                              </Icon>
                              <div className="campaigns_empty_title"> No nominees uploaded</div>
                            </div>)
                            : (<NomineeSortableTable data={nomineeList} setData={setNomineeList} categoryName={getCampaignLabel(campaignCategory.name)} showAction={false} />)
                        }
                      </>
                    )

                  }

                  {
                    editData.type == "Predefined Task Based" && (
                      <>
                        <div className="table-wrapper">
                          <table className="reward-configuration-table">
                            <thead>
                              <tr>
                                <th width="120px">
                                  Module {getSortIcon()}
                                </th>

                                <th width="110px">
                                  No. of Submission {getSortIcon()}
                                </th>

                                <th width="110px">
                                  Reward Points  {getSortIcon()}
                                </th>

                                <th >
                                  Earning Limit {getSortIcon()}
                                </th>

                                <th >
                                  Task description {getSortIcon()}
                                </th>

                                <th >
                                  Popup message {getSortIcon()}
                                </th>

                              </tr>
                            </thead>
                            <tbody>



                              {rewardConfigurationList.map((item, index) => (
                                <tr key={index}>
                                  <td className="reward-configuration-table-text">{item.module_name}</td>
                                  <td className="reward-configuration-table-text">{item.threshold}</td>
                                  <td className="reward-configuration-table-text">{item.point}</td>
                                  <td className="reward-configuration-table-text">{item.limit}</td>
                                  <td className="reward-configuration-table-text">{item.task_description}</td>
                                  <td className="reward-configuration-table-text">{item.popup_message}</td>
                                </tr>
                              ))}

                            </tbody>
                          </table>
                        </div>
                      </>
                    )

                  }



                </div>
              )}


            </div>

            <div className="campaigns-survey-footer">
              <div className="footer-left-btn-groups">
                {selected_tab !== 0 &&
                  <Button
                    className="footer-previous-btn font-family-poppins"
                    onClick={() => {
                      callback_handleBackBtn();
                    }}
                  >
                    Previous
                  </Button>
                }
                <Button
                  className="footer-previous-btn font-family-poppins"
                  onClick={() => {
                    navigate(REWARDS_CAMPAIGNS_LIST);
                  }}
                >
                  Cancel
                </Button>
              </div>

              {selected_tab !== 2 &&
                <div className="footer-right">
                  {(AdminPermssion && editData.status == "Draft") && (
                    <Button
                      className="footer-save-btn"
                      onClick={(e) => {
                        if (isEnableSaveAsDraft) {
                          handleSubmit(true, false);

                        }
                      }}
                      disabled={!isEnableSaveAsDraft}
                    >
                      Save as Draft
                    </Button>
                  )

                  }

                  <Button
                    className="footer-next-btn"
                    onClick={(e) => {
                      handleNext();

                    }}
                    disabled={disabled}
                  >
                    Next
                    <Icon>
                      <img alt="" src={NextIcon} />
                    </Icon>
                  </Button>
                </div>
              }

              {selected_tab === 2 &&
                <div className="footer-right">
                  {(AdminPermssion && editData.status == "Draft") && (<Button
                    className="footer-save-btn"
                    onClick={(e) => {
                      if (isEnableSaveAsDraft) {
                        handleSubmit(true, false);
                      }
                    }}
                    disabled={!isEnableSaveAsDraft}

                  >
                    Save as Draft
                  </Button>
                  )}


                  <Button
                    className="footer-next-btn"
                    onClick={(e) => {
                      setShowSubmitConfirmDialog(true);
                    }}
                    disabled={!AdminPermssion && ValidatorPermssion && nomineeList.length == 0 ? true : false}
                  >
                    Submit
                  </Button>
                </div>
              }

            </div>
          </div>


          {showError && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={() => setShowError(false)}
            >
              <p>{errorMessage}</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "5px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowError(false)}
                >
                  OK
                </div>
              </div>
            </Dialog>
          )}


          {showPublishStartEndDateError && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={() => setShowPublishStartEndDateError(false)}
            >
              <p>{publishStartEndDateErrorMessage}</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "5px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowPublishStartEndDateError(false)}
                >
                  Change
                </div>
              </div>
            </Dialog>
          )}

          {showDateError && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={() => setShowDateError(false)}
            >
              <p>End Date cannot be earlier than Start Date!</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "5px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowDateError(false)}
                >
                  Change
                </div>
              </div>
            </Dialog>
          )}

          {showSaveDraftDialog && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={handleCloseDialog}
            >
              <p>{saveDraftMessage}</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "5px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={handleCloseDialog}
                >
                  OK
                </div>
              </div>
            </Dialog>
          )}

          {showSubmitConfirmDialog && (
            <Dialog
              className="alert-form"
              title={"Confirmation"}
              width={500}
              // height={280}
              onClose={() => setShowSubmitConfirmDialog(false)}
            >
              {
                (AdminPermssion) ? (
                  <>
                    <p className="campaigns-dialog-text-align"><b>Are you sure you want to submit this campaign?</b></p>
                  </>
                ) :
                  (ValidatorPermssion) ? (
                    <>
                      <p className="campaigns-dialog-text-align"><b>Are you sure you want to submit this campaign?</b></p>
                      <p className="campaigns-dialog-text-align">Once submitted, you will not be able to upload files again unless the approver rejects it or the admin recreates the campaign.</p>
                    </>
                  ) :
                    (ApproverPermssion) ? (
                      <>
                        <p className="campaigns-dialog-text-align"><b>Are you sure you want to approve this campaign?</b></p>
                        <p className="campaigns-dialog-text-align">Once the campaign is approved, the validators will be able to upload the nominee lists when the start date and time is reached.</p>
                      </>
                    ) :
                      (
                        <>
                          <p className="campaigns-dialog-text-align"><b>Are you sure you want to submit this campaign?</b></p>
                        </>
                      )
              }

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "10px",
                    background: "white",
                    color: "#eb6e1f",
                    cursor: "pointer",
                    border: "1px solid #eb6e1f",
                  }}
                  onClick={() => {
                    setShowSubmitConfirmDialog(false);
                  }}
                >
                  Cancel
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setShowSubmitConfirmDialog(false);
                    handleSubmit(false, true);
                  }}
                >
                  Submit
                </div>
              </div>
            </Dialog>
          )}

          {showUploadOverrideWarning && (
            <Dialog
              className="alert-form"
              title={"Confirmation"}
              width={500}
              // height={280}
              onClose={() => setShowInvalidNomineeDialog(false)}
            >
              <p className="campaigns-dialog-text-align"><b>Confirmation for Importing</b></p>
              <p className="campaigns-dialog-text-align">Uploading this file will override all existing data with the new data from the uploaded file. Do you want to proceed?</p>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "10px",
                    background: "white",
                    color: "#eb6e1f",
                    cursor: "pointer",
                    border: "1px solid #eb6e1f",
                  }}
                  onClick={() => {
                    setTempDoc("");
                    setShowUploadOverrideWarning(false);
                  }}
                >
                  Cancel
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    onUploadDoc(tempDoc);
                    setShowUploadOverrideWarning(false);

                  }}
                >
                  Override
                </div>
              </div>
            </Dialog>
          )}

          {showInvalidNomineeDialog && (
            <Dialog
              className="alert-form"
              title={"Error Message"}
              width={500}
              // height={280}
              onClose={() => setShowInvalidNomineeDialog(false)}
            >
              <p className="campaigns-dialog-text-align">Nominees do not match your Interchange Group. Please review and upload a valid file.</p>
              <div style={{ maxHeight: '400px', overflow: 'auto' }}>
                <ErrorNomineeSortableTable data={invalidNomineeList} />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: '100%',
                    height: "40px",
                    marginTop: "10px",
                    borderRadius: "5px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowInvalidNomineeDialog(false)}
                >
                  Ok
                </div>
              </div>
            </Dialog>
          )}
        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
